/**
 * this function adds days(numeric) to input date(object). It return a Date Object
 * @param date
 * @param days
 * @returns {Date}
 */
export default (date, days) => {
  const inputDate = new Date(date.getTime())
  inputDate.setDate(inputDate.getDate() + days)
  return inputDate
}
